import factory from './icon';
import Svg from './glyphs/vuxen_logo.svg';

export default factory(Svg);
